import { el } from 'redom';

import NavigableList from 'generics/components/navigable-list/native';
import ActionsList from './actions-list';

import './index.scss';

class ActionsAndOptionsList {

  constructor(configuration) {

    this.actions = configuration.actions || [];
    this.optionsListConfiguration = configuration;
    this.entriesCount = configuration.entries.length;

    this.actionsList = null;
    this.optionsList = null;

    this.initializeActionsList();
    this.initializeOptionsList();

    this.el = el('.actions-and-actions-list-main', {
      class: 'hide-scrollbar'
    }, [this.actionsList, this.optionsList]);

  }

  initializeActionsList() {

    this.actionsList = new ActionsList(this.actions);

  }

  initializeOptionsList() {

    this.optionsList = new NavigableList({
      ...this.optionsListConfiguration,
      preventNoResultDisplay: this.actions.length > 0
    });

    if (this.optionsListConfiguration.entries.length === 0) {
      this.optionsList.showNoResultsFound();
    }

  }

  setWorking() {

    this.optionsList.setWorking();

  }

  setIdle() {

    this.optionsList.setIdle();

  }

  setEntries(entries) {

    this.entriesCount = entries.length;
    this.optionsList.setEntries(entries);

  }

  updateVisibility(searchTerm) {

    if (this.isDisplayable(searchTerm) === true) {
      this.el.classList.remove('hidden');
      return;
    }

    this.el.classList.add('hidden');

  }

  isDisplayable(searchTerm) {

    if (searchTerm !== '') {
      return true;
    }

    if (this.entriesCount > 0) {
      return true;
    }

    return this.actions.length > 0;

  }

  showNoResultsFound() {

    this.optionsList.showNoResultsFound();

  }

  showAddNewOption() {

    this.optionsList.showNoResultsFound();

  }

  selectHighlightedOption() {

    this.optionsList.selectHighlightedOption();

  }

  highlightPreviousOption() {

    this.optionsList.highlightPreviousOption();

  }

  highlightNextOption() {

    this.optionsList.highlightNextOption();

  }

  unsetFilter() {

    this.optionsList.unsetFilter();

  }

  setSelectedEntries(entries) {

    this.optionsList.setSelectedEntries(entries);

  }

  getSelectedEntries() {

    return this.optionsList.getSelectedEntries();

  }

  resetHighlighted() {
    this.optionsList.resetHighlighted();
  }

  clear() {
    this.optionsList.clear();
  }

  updateActions(option) {

    this.actionsList.update(option);

  }

  getKeyEntry(key) {

    return this.optionsList.getKeyEntry(key);

  }

}

export default ActionsAndOptionsList;